module.exports = __webpack_public_path__ + "static/img/1.32725e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/eng/1.png
// module id = itQV
// module chunks = 0